// src/store/folderStore.js

import { create } from 'zustand';
import DataHelper from '../helpers/DataHelper';
import { select } from 'async';
// You might also need to pass props related to Redux actions (like requestServerPost)

const useFileStore = create((set, get) => ({
    mediaDatas: [],

    setMediaDatas: (newFiles) => set({ mediaDatas: newFiles }),

    /**
     * Global action to fetch and update folder data.
     * @param {object} selectedBrandData - The current selected brand data.
     * @param {object} props - The Redux props needed for DataHelper (e.g., requestServerPost).
     */
    fetchMediaDatas: async (selectedBrandData, props) => {
        if (!selectedBrandData) {
            console.log("no brand data");
            get().setMediaDatas([]); // Use the getter to call the setter
            return;
        }

        const params = { brandid: selectedBrandData.BrandID };

        try {
            const data = await DataHelper.getFiles(params, props);
            if ("status" in data) {
                if (data.status === "success") {
                    get().setMediaDatas(data.data || []); // Use the getter to call the setter
                }
            } else {
                // Handle cases where data might be the array directly
                get().setMediaDatas(data || []);
            }
        } catch (err) {
            console.error("Error fetching folders:", err);
            // Optionally, handle error state here
        }
    },

    setMediaDatas: (newFiles) => set({ mediaDatas: newFiles }),
}));

export default useFileStore;